import * as React from 'react';
import { Query } from 'react-apollo';

import {
  Button, Dialog, DialogActions, DialogContent, DialogTitle,
  TableRow, TableCell, Table, TableBody, Checkbox, TextField, Snackbar, SnackbarContent
} from '@material-ui/core';
import DateRangeIcon from '@material-ui/icons/DateRange';
import { QueryFilter, QUERY_FILTER_CONSULTING_PUBLISHER } from 'src/component/shared';
import { client } from 'src';
import { MetricIndex, FilterCategoryType, GoogleAnalytics } from 'src/services/GoogleAnalytics';

const ga = new GoogleAnalytics();

// tslint:disable-next-line:no-empty-interface
export interface IConsultingPublisherPeriodFilterProps {
}

// tslint:disable-next-line:no-empty-interface
export interface IConsultingPublisherPeriodFilterState {
    alertMessage: string,
    alertOpened: boolean,
    dialogOpen: boolean,
    customFilter: {
        isChart: boolean,
        storeName: string
    },
    consultingPublisherPeriodFilterChecked: string[];
}

export const periods = [
    {
        name: 'Mensal',
        value: 'monthly'
    }, {
        name: 'Trimestral',
        value: 'quarterly'
    }, {
        name: 'Anual',
        value: 'annual'
    }
];


export class ConsultingPublisherPeriodFilter extends React.Component<IConsultingPublisherPeriodFilterProps, IConsultingPublisherPeriodFilterState> {
    constructor(props: IConsultingPublisherPeriodFilterProps) {
        super(props);
        this.state = {
            alertMessage: '',
            alertOpened: false,
            consultingPublisherPeriodFilterChecked: [],
            customFilter: {
                isChart: false,
                storeName: '',
            },
            dialogOpen: false,
        }
    }

    public render() {

        return (
            <Query query={QUERY_FILTER_CONSULTING_PUBLISHER} notifyOnNetworkStatusChange={true}  >
            {({ loading: loadingC, error: errorC, data: cache, client: clientC }) => (
                <div className="filter-item">
                    <Snackbar
                        anchorOrigin={{
                            horizontal: 'center',
                            vertical: 'center',
                        }}
                        open={this.state.alertOpened}
                        autoHideDuration={4000}
                        onClose={this.closeAlert}
                    >
                        <SnackbarContent message={this.state.alertMessage} />
                    </Snackbar>
                    <Button variant="contained" onClick={this.handleDialogOpen}>
                        <DateRangeIcon className="filter-item-icon" /><div className="filter-label">Período</div>
                    </Button>
                    <Dialog
                        open={this.state.dialogOpen}
                        onClose={this.handleDialogClose}
                        aria-labelledby="economic-group-dialog-title"
                        aria-describedby="alereconomic-group-dialog-description"
                        className="filter-dialog"
                    >
                        <DialogTitle className="filter-dialog-title" id="economic-group-dialog-title">{"Período"}</DialogTitle>
                        <DialogContent className="filter-dialog-content">
                        <TextField
                            id="filter-dialog-name"
                            className="filter-dialog-input-name"
                            label="Período"
                            value={this.state.customFilter.storeName}
                            onChange={this.handleChangeName}
                            margin="normal"
                        />
                        <Table >
                            <TableBody>
                                {periods.map((item: any) => {
                                    return (
                                        <TableRow key={item.value}>
                                            <TableCell component="th" scope="row">
                                                <Checkbox
                                                    checked={this.state.consultingPublisherPeriodFilterChecked.includes(item.value)}
                                                    onChange={this.handleChecked}
                                                    value={item.value}
                                                />
                                                <span className="filter-dialog-item">{item.name}</span>
                                            </TableCell>
                                        </TableRow>
                                    );
                                })}
                            </TableBody>
                        </Table>
                        </DialogContent>
                        <DialogActions className="filter-actions">
                        <Button className="filter-dialog-clear" onClick={this.handleDialogClear} >
                            Limpar
                    </Button>
                        <Button className="filter-dialog-close" onClick={this.handleDialogClose} >
                            Fechar
                    </Button>
                        <Button className="filter-dialog-apply" onClick={this.handleDialogApply.bind(this, clientC)} autoFocus={true}>
                            Aplicar
                    </Button>
                        </DialogActions>
                    </Dialog>
                </div>
            )}
            </Query>
        )
    }

    private handleDialogOpen = () => {
        // tslint:disable:no-string-literal
        if(client.cache['data'] != null && client.cache['data'] !== undefined 
            && client.cache['data'].data != null && client.cache['data'].data !== undefined
            && client.cache['data'].data.ROOT_QUERY != null && client.cache['data'].data.ROOT_QUERY !== undefined
            && client.cache['data'].data.ROOT_QUERY.FILTER_consultingPublisherPeriodFilterChecked != null && client.cache['data'].data.ROOT_QUERY.FILTER_consultingPublisherPeriodFilterChecked !== undefined) {

            const checkAtual = client.cache['data'].data.ROOT_QUERY.FILTER_consultingPublisherPeriodFilterChecked.json;
            this.setState({ dialogOpen: true, consultingPublisherPeriodFilterChecked: checkAtual});
        } else {
            this.setState({ dialogOpen: true, consultingPublisherPeriodFilterChecked: []});
        }
        // tslint:enable:no-string-literal
    };

    private handleDialogClose = () => {
        this.handleDialogClear();
        this.setState({ dialogOpen: false});
    };

    // tslint:disable-next-line:no-shadowed-variable
    private handleDialogApply = (client: any) => {

        if(this.state.consultingPublisherPeriodFilterChecked == null 
            || this.state.consultingPublisherPeriodFilterChecked === undefined 
            || this.state.consultingPublisherPeriodFilterChecked.length === 0) {
            this.openAlert(true, "É necessário selecionar um período");
        } else if(this.state.consultingPublisherPeriodFilterChecked != null 
            && this.state.consultingPublisherPeriodFilterChecked !== undefined 
            && this.state.consultingPublisherPeriodFilterChecked.length > 1) {
            this.openAlert(true, "Somente um período é permitido por vez");
        } else {
            client.writeData({ data: { consultingPublisherPeriodFilterChecked: this.state.consultingPublisherPeriodFilterChecked } });
            client.writeData({ data: { FILTER_consultingPublisherPeriodFilterChecked: this.state.consultingPublisherPeriodFilterChecked } });
            QueryFilter.updateMutationConsultingPublisherFilter();
            this.setState({ dialogOpen: false });
            const metricName = 'metric'+MetricIndex.FILTER;
            ga.fireEventTracking(FilterCategoryType.DATE, 'filter', 'consulting-publisher', false, metricName);
        }
    }

    private handleDialogClear = () => {
        this.setState({
            consultingPublisherPeriodFilterChecked: [],
            customFilter: {
                isChart: false,
                storeName: '',
            },
        });
    }

    private handleChangeName = (event: React.FormEvent<HTMLInputElement>) => {
        this.setState({
            customFilter: {
                isChart: false,
                storeName: event.currentTarget.value,
            }
        });
    };

    private handleChecked = (event: React.FormEvent<HTMLInputElement>) => {
        
        let { consultingPublisherPeriodFilterChecked } = this.state;
        const { value } = event.currentTarget;

        if (consultingPublisherPeriodFilterChecked.includes(value)) {
            consultingPublisherPeriodFilterChecked = consultingPublisherPeriodFilterChecked.filter((item: string) => item !== value)
            this.setState({ consultingPublisherPeriodFilterChecked });
        } else {
            if(consultingPublisherPeriodFilterChecked != null && consultingPublisherPeriodFilterChecked !== undefined && consultingPublisherPeriodFilterChecked.length > 0) {
                this.openAlert(true, "Somente um período é permitido por vez");
            } else {
                consultingPublisherPeriodFilterChecked = [...consultingPublisherPeriodFilterChecked, value];
                this.setState({ consultingPublisherPeriodFilterChecked });
            }
        }
    }

    private openAlert(alertOpened: boolean, alertMessage: string) {
        this.setState({ alertMessage, alertOpened })
    }

    private closeAlert = (event: object, reason: string) => {
        if (reason === 'clickaway') {
            return;
        }
        this.setState({ alertOpened: false });
    }
}


// WEBPACK FOOTER //
// ./src/component/consulting/publisher/shared/filter/period/ConsultingPublisherPeriodFilter.tsx